import React from "react";

const Footer = () => {
  return (
    <footer>
      <div>
        <h1>TechyStack</h1>
        <p>@all right reserved</p>
      </div>

      <div>
        <h5>Follow Us</h5>
        <div>
          <a href="https://www.linkedin.com/in/lovepreet-singh1223/" target={"blank"}>
            Linkedin
          </a>
          
          <a href="https://github.com/Singh-1223" target={"blank"}>
            Github
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;